module.exports = __webpack_public_path__ + "img/phone-primary.fe2f1a5.svg";